module.exports = __webpack_public_path__ + "static/media/armored-stickleback.b9808be9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fish/armored-stickleback.png
// module id = 292
// module chunks = 0